<template>
  <result-card
    image="/img/promised-payment-activated.png"
    :title="title"
    :note="note"
    action-label="Вернуться к заказам"
    @action="$emit('action')"
  >
    <p class="promised-activated__term">
      +{{ days }} дней
    </p>
  </result-card>
</template>

<script>
  import ResultCard from './ResultCard'

  export default {
    name: 'PromisedActivated',
    components: { ResultCard },
    props: {
      days: {
        type: Number,
        default: 0,
      },
      // Отсрочку взяли заранее: срок пойдёт только когда кончатся деньги на балансе
      pending: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      title () {
        return this.pending ? 'Обещанный платеж включён!' : 'Обещанный платеж активирован!'
      },
      note () {
        return this.pending
          ? 'Сработает, когда закончатся деньги на балансе'
          : 'Можно продолжать работу...'
      },
    },
  }
</script>

<style lang="less" scoped>
.promised-activated__term {
  margin: 0 0 10px;
  font-size: 26px;
  font-weight: 700;
  color: #27ae60;
}
</style>
